import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import appUrl from "../../appUrl";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import { FaPlus, FaArrowLeft } from "react-icons/fa6";
import { Button, Spinner, Modal,Dropdown } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

import "./Table.css";

const AgentTable = () => {
  const navigate = useNavigate();
  const AppUrl = appUrl();
  const [dataLoading, setDataLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(4);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [formData, setFormData] = useState({
    edit: { agent_name: "", email: "", mobile_number: "" },
    new: { agent_name: "", email: "", mobile_number: "" },
  });
  const [refreshData, setRefreshData] = useState(false);
  const [errors, setErrors] = useState({});
  
  
  
  
  useEffect(() => {
    const fetchAgents = async () => {
      setDataLoading(true);
      const token = localStorage.getItem("token");
      try {
        const response = await fetch(`${AppUrl}/agents`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (data.status) {
          setProjects(data.data);
          setTotalCount(data.data.length);
        } else {
          toast.error("Failed to fetch data");
        }
      } catch (error) {
        toast.error("Error fetching reports");
      } finally {
        setDataLoading(false);
      }
    };
    fetchAgents();
  }, [AppUrl, refreshData]);

  const columns = [
    {
      dataField: "index",
      text: "S No.",
      formatter: (cell, row, rowIndex) =>
        pageSize * (currentPage - 1) + rowIndex + 1,
      headerStyle: { width: "80px" },
    },
    {
      dataField: "agent_name",
      text: "Name",
      headerStyle: { width: "80px" },
    },
    {
      dataField: "email",
      text: "Email",
      headerStyle: { width: "180px" },
    },
    {
      dataField: "mobile_number",
      text: "Phone no.",
      headerStyle: { width: "180px" },
    },
    {
      dataField: "agent_code",
      text: "Agent Code",
      headerStyle: { width: "180px" },
    },
    {
      text: "Actions",
      formatter: (cell, row) => (
        <div className="flex justify-center items-center">
          <Button
            onClick={() => handleModal("edit_agent", row)}
            variant="primary"
            size="sm"
            className="mx-1 edit-button-lg"
            style={{ width: '70px',  padding: '6px 2px'}}
          >
            Edit
          </Button>
          <Button
            onClick={() => handleModal("delete_agent", row)}
            variant="danger"
            size="sm"
            className="delete-button-lg"
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  const handlePageChange = (page, sizePerPage) => {
    setCurrentPage(page);
    setPageSize(sizePerPage);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalContent(null);
  };

  const handleModal = (behaviour, row) => {
    if (behaviour === "add_agent") {
      setFormData((prev) => ({
        ...prev,
        new: { agent_name: "", email: "", mobile_number: "" },
      }));
    } else if (behaviour === "edit_agent") {
      setFormData((prev) => ({
        ...prev,
        edit: {
          agent_name: row.agent_name,
          email: row.email,
          mobile_number: row.mobile_number,
        },
      }));
    }
    setErrors({});
    setModalContent({ behaviour, row });
    setShowModal(true);
  };

  const handleAddNewAgent = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    let newErrors = {};
    Object.keys(formData.new).forEach((key) => {
      if (key !== "mobile_number" && !formData.new[key].trim()) {
        let formattedName = key
          .replace("_", " ")
          .replace(/\b\w/g, (char) => char.toUpperCase());
        newErrors[key] = `${formattedName} is required`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setDataLoading(true);
    try {
      const response = await fetch(`${AppUrl}/create-agent`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData.new),
      });

      const data = await response.json();
      if (!response.ok || !data.status) {
        throw new Error(data.message || "Error while creating agent");
      }

      toast.success("Agent created successfully!");
      setRefreshData((prev) => !prev);
      handleCloseModal();
    } catch (error) {
      toast.error(error.message || "Error while creating agent");
    } finally {
      setDataLoading(false);
    }
  };

  const handleEditAgent = async (e, id) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    let newErrors = {};
    Object.keys(formData.edit).forEach((key) => {
      if (key !== "mobile_number" && !formData.edit[key].trim()) {
        let formattedName = key
          .replace("_", " ")
          .replace(/\b\w/g, (char) => char.toUpperCase());
        newErrors[key] = `${formattedName} is required`;
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setDataLoading(true);
    try {
      const response = await fetch(`${AppUrl}/edit-agent?id=${id}`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData.edit),
      });

      const data = await response.json();
      if (!response.ok || !data.status) {
        throw new Error(data.message || "Error while editing agent details");
      }
      toast.success("Agent details edited successfully!");
      setRefreshData((prev) => !prev); // Trigger re-fetch
      handleCloseModal();
    } catch (error) {
      toast.error(error.message || "Error while creating agent");
    } finally {
      setDataLoading(false);
    }
  };

  const handleDeleteAgent = async (e, id) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    try {
      setDataLoading(true);
      const response = await fetch(`${AppUrl}/delete-agent?id=${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      if (!response.ok || !data.status)
        throw new Error("Error while deleting agent");
      toast.success("Agent deleted successfully!");
      setRefreshData((prev) => !prev); // Trigger re-fetch
      handleCloseModal();
    } catch (error) {
      toast.error(error.message || "Error while deleting agent");
    } finally {
      setDataLoading(false);
    }
  };

  return (
    <>
      <ToastContainer />
      {dataLoading ? (
        <div className="loading-spinner">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <div className="flex items-center">
            <div className="flex items-center justify-between">
              <div onClick={() => navigate(-1)} className="back-button">
                <FaArrowLeft />
              </div>
            </div>

            <div style={{ position: "relative", marginLeft: "auto" }}>
              <Button
                className="add-item-modal-open-btn flex gap-1 items-center justify-center border-none"
                onClick={() => {
                  handleModal("add_agent", null);
                }}
              >
                <FaPlus/>
                <span>Add new Agent</span>
              </Button>
            </div>
          </div>
          <BootstrapTable
            bootstrap4
            keyField="_id"
            data={projects}
            columns={columns}
            filter={filterFactory()}
            pagination={paginationFactory({
              page: currentPage,
              sizePerPage: pageSize,
              totalSize: totalCount,
              onPageChange: handlePageChange,
              showTotal: true,
              sizePerPageRenderer: () => null,
              paginationTotalRenderer: (from, to, total) => (
                <div className="pagination-and-entries">
                    <p className="entries">
                        Showing {from} to {to} of {total} entries
                    </p>
                </div>
              )
            })}
          />
        </>
      )}
      <Modal show={showModal} onHide={handleCloseModal}>
        <form>
          <Modal.Header closeButton>
            <Modal.Title>
              {modalContent?.behaviour === "edit_agent"
                ? `Edit Agent`
                : modalContent?.behaviour === "delete_agent"
                ? "Delete Agent"
                : "Add New Agent"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {modalContent?.behaviour === "edit_agent" && (
              <ModalBodyContent
                errors={errors}
                setErrors={setErrors}
                behaviour={modalContent.behaviour}
                data={formData.edit}
                setData={(data) =>
                  setFormData({
                    ...formData,
                    edit: { ...formData.edit, ...data },
                  })
                }
              />
            )}
            {modalContent?.behaviour === "add_agent" && (
              <ModalBodyContent
                errors={errors}
                setErrors={setErrors}
                behaviour={modalContent.behaviour}
                data={formData.new}
                setData={(data) =>
                  setFormData({
                    ...formData,
                    new: { ...formData.new, ...data },
                  })
                }
              />
            )}
            {modalContent?.behaviour === "delete_agent" && (
              <div className="content-center">
                <p>Do you want to Delete</p>
                <p className="font-bold mx-1">{modalContent.row.agent_name}</p>
                <p>Agent ?</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button className='modal-cancel-btn' variant="secondary" onClick={handleCloseModal}>
              Cancel
            </Button>
            {modalContent?.behaviour === "edit_agent" && (
              <Button
                disabled={dataLoading}
                className="modal-edit-btn"
                type="submit"
                onClick={(e) => handleEditAgent(e, modalContent.row._id)}
              >
                {dataLoading ? 
                  <div className='flex-center'>
                      <Spinner style={{ width: '25px', height: '25px'}} animation="border" role="status" />
                  </div>
                  : 
                  <span>Save Changes</span>}
              </Button>
            )}
            {modalContent?.behaviour === "delete_agent" && (
              <Button
                disabled={dataLoading}
                className="modal-delete-btn"
                variant="danger"
                onClick={(e) => handleDeleteAgent(e, modalContent.row._id)}
              >
                {dataLoading ? 
                  <div className='flex-center'>
                      <Spinner style={{ width: '25px', height: '25px'}} animation="border" role="status" />
                  </div>
                  : 
                  <span>Delete Agent</span>}
              </Button>
            )}
            {modalContent?.behaviour === "add_agent" && (
              <Button
                disabled={dataLoading}
                className="modal-add-btn"
                type="submit"
                variant="primary"
                onClick={handleAddNewAgent}
              >
                {dataLoading ? 
                  <div className='flex-center'>
                      <Spinner style={{ width: '25px', height: '25px'}} animation="border" role="status" />
                  </div>
                  : 
                  <span>Create Agent</span>}
              </Button>
            )}
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default AgentTable;

export const ModalBodyContent = ({
  behaviour,
  data,
  setData,
  errors,
  setErrors,
}) => {

  
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    data[name] = value;
    setData(data);

    if (name !== "mobile_number") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: value.trim() ? "" : prevErrors[name],
      }));
    }
  };

  const handleCountryCodeSelect = (code) => {
    setData(prev => ({ ...prev, country_code: code }));
  };
  

  const countryCodes = [
    { flag: '🇺🇸', code: '+1' },    // United States
    { flag: '🇨🇦', code: '+1' },    // Canada
    { flag: '🇮🇳', code: '+91' },   // India
    { flag: '🇬🇧', code: '+44' },   // United Kingdom
    { flag: '🇦🇺', code: '+61' },   // Australia
    { flag: '🇳🇿', code: '+64' },   // New Zealand
    { flag: '🇩🇪', code: '+49' },   // Germany
    { flag: '🇫🇷', code: '+33' },   // France
    { flag: '🇮🇹', code: '+39' },   // Italy
    { flag: '🇪🇸', code: '+34' },   // Spain
    { flag: '🇧🇷', code: '+55' },   // Brazil
    { flag: '🇲🇽', code: '+52' },   // Mexico
    { flag: '🇯🇵', code: '+81' },   // Japan
    { flag: '🇨🇳', code: '+86' },   // China
    { flag: '🇰🇷', code: '+82' },   // South Korea
    { flag: '🇷🇺', code: '+7' },    // Russia
    { flag: '🇿🇦', code: '+27' },   // South Africa
    { flag: '🇸🇦', code: '+966' },  // Saudi Arabia
    { flag: '🇦🇪', code: '+971' },  // UAE
    { flag: '🇸🇬', code: '+65' },   // Singapore
    { flag: '🇹🇷', code: '+90' },   // Turkey
    { flag: '🇮🇩', code: '+62' },   // Indonesia
    { flag: '🇹🇭', code: '+66' },   // Thailand
    { flag: '🇳🇬', code: '+234' },  // Nigeria
  ];
  

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const formattedName = name
      .replace("_", " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value.trim() ? "" : `${formattedName} is required`,
    }));
  };

  

  return (
    <div className="content-center flex-col p-2 gap-3">
      <div className="bg-light w-100 border border-secondary rounded p-2 pt-1 background-color-blue">
        <p className="text-sm text-muted">Name*</p>
        <input
          name="agent_name"
          value={data.agent_name}
          onBlur={handleBlur}
          onChange={(e) => handleInputChange(e)}
          className="text-indent-1 bg-light text-lg w-100 outline-none border-none"
          type="text"
        />
        {errors.agent_name && (
          <p className="text-red-500 text-sm mt-1">{errors.agent_name}</p>
        )}
      </div>
      <div className="bg-light w-100 border border-secondary rounded p-2 pt-1 background-color-blue">
        <p className="text-sm text-muted">Email*</p>
        <input
          name="email"
          value={data.email}
          onBlur={handleBlur}
          onChange={(e) => handleInputChange(e)}
          className="text-indent-1 bg-light text-lg w-100 outline-none border-none"
          type="email"
        />
        {errors.email && (
          <p className="text-red-500 text-sm mt-1">{errors.email}</p>
        )}
      </div>
      {/* <div className="bg-light w-100 border border-secondary rounded p-2 pt-1 background-color-blue">
        <p className="text-sm text-muted">Mobile Number</p>
        <input
          name="mobile_number"
          value={data.mobile_number}
          onChange={handleInputChange}
          className="text-indent-1 bg-light text-lg w-100 outline-none border-none"
          type="text"
        />
      </div> */}
  <div className="bg-light w-100 border border-secondary rounded p-2 pt-1 ">
  <p className="text-sm text-muted">Mobile Number</p>
  <div className="d-flex align-items-center">
    <Dropdown className="me-2">
      <Dropdown.Toggle variant="outline-secondary" size="sm">
        {/* {true 
          ? `${countryCodes.find(c => c.code === "+1")?.flag} +1` 
          : 'Code'} */}
                  {data.country_code
          ? `${countryCodes.find(c => c.code === data.country_code)?.flag || ''} ${data.country_code}`
          : 'Select Code'}

          
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {countryCodes.map((item) => (
          <Dropdown.Item
            key={item.flag + item.code}
            onClick={() => handleCountryCodeSelect(item.code)}
          >
            <span className="me-2">{item.flag}</span>
            {item.code}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>

    <div className="flex-grow-1">
      {/* <p className="text-sm text-muted mb-1">Mobile Number</p> */}
      <input
        name="mobile_number"
        value={data.mobile_number}
        onChange={handleInputChange}
        className="bg-light text-lg w-100 border-0"
        type="text"
        placeholder="+0000000000"
      />
    </div>
  </div>
</div>


    </div>
  );
};
